module.exports = __webpack_public_path__ + "img/project.0d96819c.svg";